const NVZNART_PLAYER_URL = 'https://art.nvzn.io';

// generate nvzn art preview url
function getNvznArtPreviewUrl({
    accountID, // required
    productID, // required
    imageSource, // required
    width, // required
    height, // required
    units = 'in', // optional, defaults to Inches
    language = 'en', // optional, defaults to English
} = {}) {
    // validation
    if (!accountID) throw new Error('Nvzn accountID is required');
    if (!productID) throw new Error('Nvzn productID is required');
    if (!imageSource) throw new Error('Nvzn imageSource is required');
    if (!width) throw new Error('Nvzn width is required');
    if (!height) throw new Error('Nvzn height is required');
    // build url
    const baseUrl = NVZNART_PLAYER_URL;
    const url = new URL(baseUrl);
    const params = {
        a: accountID,
        p: productID,
        i: imageSource,
        w: width,
        h: height,
        u: units,
        l: language,
    };
    url.search = new URLSearchParams(params).toString();
    return url;
}

function openNvznArtPreview({
    accountID, // required
    productID, // required
    imageSource, // required
    width, // required
    height, // required
    units = 'in', // optional, defaults to Inches
    language = 'en', // optional, defaults to English
    tracking = false, // optional, defaults to false
} = {}) {
    // get iframe preview url
    const url = getNvznArtPreviewUrl({
        accountID,
        productID,
        imageSource,
        width,
        height,
        units,
        language,
    });

    if(tracking) {
        trackCustomEvent('view_ar');
    }

    let maxZIndex = 0;
    document.querySelectorAll('*').forEach((element) => {
        const zIndex = parseInt(window.getComputedStyle(element).zIndex, 10);
        if (!isNaN(zIndex) && zIndex > maxZIndex) {
            maxZIndex = zIndex;
        }
    });
    const modal = document.createElement('div');
    modal.id = 'nvznart-modal';
    modal.classList.add('nvznart-modal', 'nvznart-showable');
    modal.style.zIndex = maxZIndex + 1;
    modal.innerHTML = `
            <div id="nvznart-loader-container" class="nvznart-centered-container">
              <svg class="nvznart-loading-spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <polyline points="0,25 0,0 25,0" fill="none" stroke="#FAFAFA" stroke-width="10"/>
                <polyline points="75,0 100,0 100,25" fill="none" stroke="#FAFAFA" stroke-width="10"/>
                <polyline points="100,75 100,100 75,100" fill="none" stroke="#FAFAFA" stroke-width="10"/>
                <polyline points="25,100 0,100 0,75" fill="none" stroke="#FAFAFA" stroke-width="10"/>
              </svg>
            </div>
            <div class="nvznart-centered-container">
              <svg id="nvznart-modal-close" class="nvznart-modal-close nvznart-showable" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                <circle cx="15" cy="15" r="14" fill="rgba(64,64,64,0.8)"></circle>
                <line x1="10" y1="10" x2="20" y2="20" stroke="white" stroke-width="1.5"></line>
                <line x1="20" y1="10" x2="10" y2="20" stroke="white" stroke-width="1.5"></line>
              </svg>
              <iframe
                id="nvznart-iframe"
                src=""
                style="width: 100%; height: 100%; border: none;"
                allow="xr-spatial-tracking *; clipboard-write *; fullscreen *; web-share;"
                allowfullscreen
                mozallowfullscreen
                webkitallowfullscreen
              ></iframe>
            </div>
          `;
    modal.querySelector('#nvznart-iframe').src = url;
    modal.querySelector('#nvznart-iframe').style.display = 'none';
    document.body.style.overflow = 'hidden';
    modal.addEventListener('click', closeNvznArtPreview);
    modal
        .querySelector('#nvznart-modal-close')
        .addEventListener('click', closeNvznArtPreview);
    window.addEventListener('keydown', nvznArtHandleEscape);
    modal.querySelector('#nvznart-iframe').addEventListener('load', () => {
        document.querySelector('#nvznart-loader-container').remove();
        document
            .querySelector('#nvznart-modal-close')
            .classList.add('nvznart-show');
        document.querySelector('#nvznart-iframe').style.display = 'block';
    });
    document.body.appendChild(modal);
    requestAnimationFrame(() => {
        modal.classList.add('nvznart-show');
    });
}

function closeNvznArtPreview() {
    const modal = document.querySelector('#nvznart-modal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
        document.body.removeChild(modal);
        window.removeEventListener('keydown', nvznArtHandleEscape);
    }
}

function nvznArtHandleEscape(event) {
    if (event.key === 'Escape') {
        closeNvznArtPreview();
    }
}

function trackCustomEvent(eventName, params = {}) {
  if (typeof gtag === 'function') {
    gtag('event', eventName, params);
  } else if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: eventName, ...params });
  } else {
    console.warn(`[NVZN] No GA4 tracking detected. Event "${eventName}" not sent.`);
  }
}